import { toast } from "sonner";
import { useCreateSameDayCancellationMutation } from "@/mutations/useCreateSameDayCancellationMutation";
import { useDeleteSameDayCancellationMutation } from "@/mutations/useDeleteSameDayCancellationMutation";

type CreateArgs = {
  phone: string;
  clubId: string;
  exerciseId: string;
  exerciseTitle: string;
  exerciseTime: string;
  /** Текст для description в успешном тосте. */
  toastDescription?: string;
};

type DeleteArgs = {
  phone: string;
  cancellationId: number;
};

export const useSameDayCancelActions = () => {
  const { mutateAsync: createMutation } = useCreateSameDayCancellationMutation();
  const { mutateAsync: deleteMutation } = useDeleteSameDayCancellationMutation();

  const create = async (args: CreateArgs) => {
    try {
      await createMutation({
        phone: args.phone,
        clubId: args.clubId,
        data: {
          exercise_id: args.exerciseId,
          exercise_title: args.exerciseTitle,
          exercise_time: args.exerciseTime,
        },
      });
      toast.success("Запрос на отмену отправлен", { description: args.toastDescription });
      return true;
    } catch (error) {
      console.error("Same-day cancellation create failed", error);
      toast.error("Ошибка", {
        description: "Не удалось отправить запрос на отмену. Обратитесь к администратору.",
      });
      return false;
    }
  };

  const remove = async (args: DeleteArgs) => {
    try {
      await deleteMutation({ phone: args.phone, id: args.cancellationId });
      toast.success("Запрос на отмену удалён");
      return true;
    } catch (error) {
      console.error("Same-day cancellation delete failed", error);
      toast.error("Ошибка", { description: "Не удалось удалить запрос на отмену." });
      return false;
    }
  };

  return { create, remove };
};
